import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const MobileScreenRecord = Record({
  //#!if mobile === true || harvard === true
  // screen dimensions for mobile
  screenWidth: null,
  isPortraitMode: false
  //#!endif
});

createFromJS.registerCallback("MobileScreenRecord", createFromJS.createPrimitiveCallback(MobileScreenRecord));
